import React, { useContext, useEffect } from "react";
import { Row, Col, Card, Form, Input, Button, Divider, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import AuthLayout from "../../../layouts/auth.dashboard";
import Sidebar from "../../../components/sidebar/left";
import { UserContext } from "../../../context/UserContext";

import { getDatabase, ref, update } from "firebase/database";
import { openError, openSuccess } from "../../../utils/helper/message";
import { notification } from "antd";

const { Item } = Form;

const MyProfilePage = () => {
  const { user, setUser } = useContext(UserContext);
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        firstName: user.firstname || "",
        lastName: user.lastname || "",
        email: user.email || "",
        phone: user.phone || "",
      });
    }
  }, [user, form]);

  const handleSubmit = async (values) => {
    if (!user?.uid) return;

    try {
      const db = getDatabase();
      await update(ref(db, `landlords/${user.uid}`), {
        firstname: values.firstName,
        lastname: values.lastName,
        phone: values.phone,
      });

      setUser((prev) => ({
        ...prev,
        firstname: values.firstName,
        lastname: values.lastName,
        phone: values.phone,
      }));

      openSuccess(api, "Profile updated successfully");
    } catch (err) {
      console.error("Failed to update profile:", err);
      openError(api, err.message || "Profile update failed");
    }
  };

  return (
    <>
      {contextHolder}
      <Row justify="center" style={{ marginTop: "2rem" }}>
        <Col xs={24} sm={20} md={16} lg={12}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <Avatar size="large" icon={<UserOutlined />} />
                <span>My Profile</span>
              </div>
            }
            bordered={false}
          >
            <Form layout="vertical" form={form} onFinish={handleSubmit}>
              <Item
                label="First Name"
                name="firstName"
                rules={[{ required: true, message: "First name is required" }]}
              >
                <Input placeholder="Enter first name" size="large" />
              </Item>

              <Item
                label="Last Name"
                name="lastName"
                rules={[{ required: true, message: "Last name is required" }]}
              >
                <Input placeholder="Enter last name" size="large" />
              </Item>

              <Item
                label="Phone"
                name="phone"
                rules={[
                  { required: true, message: "Phone number is required" },
                ]}
              >
                <Input placeholder="Enter phone number" size="large" />
              </Item>

              <Item label="Email" name="email">
                <Input disabled size="large" />
              </Item>

              <Divider />

              <Item>
                <Button type="primary" htmlType="submit" block size="large">
                  Save Changes
                </Button>
              </Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MyProfilePage;
